export interface Platform {
  id: string;
  name: string;
  slug: string;
  uri: string;
}